<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Property'
}
</script>

<style scoped>

</style>
